import { createConfirmation } from "react-confirm";
import MessageOneModal from "./MessageOneModal";

export const showMessageOneModal = createConfirmation(MessageOneModal);
